import React, { useState } from 'react'
import { Form, Icon, Input, Modal, Row, Select, Upload, Radio, Col, Button } from 'antd'
import { EQUIPMENT_CATEGORY, HERO_TYPE, HERO_TYPE_MESSAGE } from '../../../../utils/constants'

const HeroDetailForm = (props) => {
  const { visible, onCancel, formData } = props
  console.log(formData)

  return (
    <Modal
      visible={visible}
      title='รายละเอียดผู้ขอใบเสนอราคา'
      footer={null}
      onCancel={onCancel}
    >
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ชื่อผู้ขอใบเสนอราคา : </h4>
        </Col>
        <Col>
          <div>{formData.heroName}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ประเภทฮีโร่ : </h4>
        </Col>
        <Col>
          <div>{HERO_TYPE_MESSAGE[formData.heroType]}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>เบอร์โทรศัพท์ : </h4>
        </Col>
        <Col>
          <div>{formData.tel}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>อีเมล์ : </h4>
        </Col>
        <Col>
          <div>{formData.heroEmail}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>LINE ID : </h4>
        </Col>
        <Col>
          <div>{formData.heroLineId}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ชื่อผู้รับผิดชอบ : </h4>
        </Col>
        <Col>
          <div>{formData.heroFullName}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col>
          <h4>ที่อยู่ : </h4>
        </Col>
        <Col>
          <div>{formData.heroAddress}</div>
        </Col>
      </Row>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ปิด</Button>
        </Col>
      </Row>
    </Modal>
  )
}

const WrappedHeroDetailForm = Form.create({
  name: 'HeroDetailForm'
})(HeroDetailForm)
export default (WrappedHeroDetailForm)



// WEBPACK FOOTER //
// ./src/pages/Quotation/components/HeroForm/index.js